<template>
    <v-navigation-drawer
      v-model="$store.state.drawer"
      absolute
      dark
      class="hidden-print-only body-1"
      id="va-drawer"
      color="primary"
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="$store.state.applogo"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>BLUEFIN</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      
      <v-list dense>  
      <v-list-item-group color="fff">
          <v-list-item
          v-for="(item, i) in MAIN_MENU"
          :key="i + '-main'"
          @click="$router.push(item.page).catch(err => {})"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" class="caption"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-expansion-panels accordion :flat="true"  :multiple="true" >
          <v-expansion-panel v-if="ADMIN_MENU.length > 0">
            <v-expansion-panel-header class="pa-3"><span class="caption">ADMIN</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0 elevation-0">
              <v-list-item
                  v-for="(item, i) in ADMIN_MENU"
                  :key="i + '-admin'"
                  @click="$router.push(item.page).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title" class="caption"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
            </v-expansion-panel>


          <v-expansion-panel v-if="REPORTS_MENU.length > 0">
            <v-expansion-panel-header  class="pa-3"><span class="caption">REPORTS</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list-item
                 v-for="(item, i) in REPORTS_MENU"
                :key="i + '-reports'"
                @click="$router.push(item.page).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title" class="caption"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>
          
           <v-expansion-panel v-if="ACCOUNTING_MENU.length > 0">
            <v-expansion-panel-header class="pa-3"><span class="caption">LEDGERS</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list-item
                 v-for="(item, i) in ACCOUNTING_MENU"
                :key="i + '-accounting'"
                @click="$router.push(item.page).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title" class="caption"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>


          <v-expansion-panel v-if="APPS_MENU.length > 0">
            <v-expansion-panel-header class="pa-3"><span class="caption">APPS</span></v-expansion-panel-header>
            <v-expansion-panel-content class="pa-0">
              <v-list-item
                 v-for="(item, i) in APPS_MENU"
                :key="i + '-apps'"
                @click="$router.push(item.page).catch(err => {})"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title" class="caption"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>
          
        </v-expansion-panels>


      </v-list-item-group>
    </v-list>


    </v-navigation-drawer>

</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data () {
      return {
        item: 1,
        mainmenu: [
          { title: 'DASHBOARD', icon: 'mdi-view-dashboard', page:'/dashboard'},
          { title: 'TRANSACTIONS', icon: 'mdi-format-list-bulleted-type', page:'/transactions'}
        ],
        admin: [
          { title: 'USERS', icon: 'mdi-account-tie', page:'/users'},
          { title: 'FISHCARS', icon: 'mdi-truck-check', page:'/fishcars'},
          { title: 'CUSTOMERS', icon: 'mdi-account-group', page:'/customers'},
          { title: "FISH KINDS", icon: 'mdi-fish', page:'/kinds'},
          //{ title: "ADMIN CASHIER", icon: 'mdi-cash-register', page:'/admin-cashier'},
          { title: "SETTINGS & CHARGES", icon: 'mdi-cogs', page:'/settings'},
          { title: "Payment Monitoring", icon: 'mdi-monitor-eye', page:'/monitoring'},
        ],
         apps: [
          { title: 'DISPATCHER', icon: 'mdi-transfer', page:'/dispatcher'},
          { title: 'ENCODER', icon: 'mdi-file-document-edit', page:'/encoder'},
           { title: 'WEIGHER', icon: 'mdi-weight-kilogram', page:'/weigher'},
          { title: 'CASHIER', icon: 'mdi-cash-register', page:'/cashier'}
        ],
        reports: [
          { title: 'Daily Fishcar Sales', icon: 'mdi-calendar-month-outline', page:'/fishcar-reports'},
          { title: 'Daily Summary', icon: 'mdi-calendar-check', page:'/daily-summary-reports'},
          // { title: 'Cashier Summary', icon: 'mdi-file-document-box-check-outline', page:'/cashier-summary'},
          { title: 'Analytics', icon: 'mdi-chart-bar', page:'/analytic-reports'}
        ],
        accounting: [
            { title: 'Fishcar', icon: 'mdi-truck-delivery', page:'/fishcar-ledger'},
            { title: 'Customer History', icon: 'mdi-credit-card-search-outline', page:'/customer-ledger'},
             { title: 'CREDIT COLLECTION', icon: 'mdi-list-box-outline', page:'/credit-collection'}
          ],
        mini: true,
      }
    },
    computed: {
      MAIN_MENU() {
        if(this.$session.get('role') == 'dispatcher') {
          return [
            { title: 'Dispatcher', icon: 'mdi-file-document-edit', page:'/dispatcher'},
            { title: 'TRANSACTIONS', icon: 'mdi-format-list-bulleted-type', page:'/transactions'}
            ]
        }
         if(this.$session.get('role') == 'headpatcher') {
          return [
              { title: 'Dispatcher', icon: 'mdi-file-document-edit', page:'/dispatcher'},
              { title: 'TRANSACTIONS', icon: 'mdi-format-list-bulleted-type', page:'/transactions'},
              { title: 'FISHCARS', icon: 'mdi-truck-check', page:'/fishcars'},
              { title: 'CUSTOMERS', icon: 'mdi-account-group', page:'/customers'},
              { title: "FISH KINDS", icon: 'mdi-fish', page:'/kinds'},
            ]
        }
        if(this.$session.get('role') == 'encoder') {
          return [
              { title: 'ENCODER', icon: 'mdi-file-document-edit', page:'/encoder'},
              { title: 'TRANSACTIONS', icon: 'mdi-format-list-bulleted-type', page:'/transactions'}
            ]
        }
        if(this.$session.get('role') == 'cashier') {
          return [
             { title: 'CASHIER', icon: 'mdi-cash-register', page:'/cashier'},
              { title: 'Daily Fishcar Sales', icon: 'mdi-calendar-month-outline', page:'/fishcar-reports'},
             // { title: 'Daily Summary', icon: 'mdi-file-document-box-multiple', page:'/daily-summary-reports'},
            ]
        }
        if(this.$session.get('role') == 'weigher') {
          return [
             { title: 'WEIGHER', icon: 'mdi-weight-kilogram', page:'/weigher'},
              { title: 'TRANSACTIONS', icon: 'mdi-format-list-bulleted-type', page:'/transactions'}
            ]
        }
        return this.mainmenu
      },
      ADMIN_MENU() {
        if(this.$session.get('role') == 'administrator') {
          return this.admin
        }
         return []
        
      },
      APPS_MENU() {
        if(this.$session.get('role') == 'administrator') {
           return this.apps
        }
        return []
      },
      REPORTS_MENU() {
        if(this.$session.get('role') == 'administrator') {
           return this.reports
        }
        return []
      },
       ACCOUNTING_MENU() {
         if(this.$session.get('role') == 'administrator') {
          return this.accounting
        }
        return []
      }
    },
    methods: {
      ...mapMutations(['setDrawer']),
    }
  }
</script>